<section
  class="pagination-section table-responsive"
  *ngIf="pagination?.totalPages > 1"
>
  <mat-paginator
    data-cy="pagination"
    [pageIndex]="pagination?.number"
    [length]="pagination?.totalElements"
    [pageSize]="pagination?.size"
    [hidePageSize]="true"
    (page)="change($event)"
  >
  </mat-paginator>
</section>
